import { render } from "./index.vue?vue&type=template&id=5688d1da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=5688d1da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5688d1da"

export default script